import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const RdnaRouterLink = styled(Link)<{ $bold?: boolean }>`
  font-weight: ${({ $bold = true }) => ($bold ? 'bold' : 'normal')};
  text-decoration: none;
`
